import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Typography } from "@mui/material";
import { COLORS } from "../../constants";
import { formatCategoryName } from "../../utils/helpers";
import useSystemHook from "./../../hooks/SystemHook";

const Breadcrumbs = ({ segmentLabels = {} }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const { isMobile } = useSystemHook();

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      sx={{
        mt: 3,
        fontSize: isMobile ? "var(--font-size-xxs)" : "var(--font-size-s)",
      }}
    >
      <Link
        to="/"
        style={{
          textDecoration: "none",
          color: COLORS.darkText,
        }}
      >
        Home
      </Link>

      {pathnames.map((pathname, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        let displayName =
          segmentLabels[pathname] ??
          formatCategoryName(
            pathname.charAt(0).toUpperCase() + pathname.slice(1),
          );

        // Special handling for Merchandising section to avoid duplication
        if (pathname.toLowerCase() === "merchandising") {
          displayName = "Merchandising";
        } else if (
          index > 0 &&
          pathnames[index - 1].toLowerCase() === "merchandising"
        ) {
          // This is a subcategory (beta, m7, flight)
          displayName = pathname.toUpperCase(); // Show as BETA, M7, FLIGHT
        }

        return (
          <span key={routeTo}>
            {" > "}
            {!isLast ? (
              <Link
                to={routeTo}
                style={{
                  textDecoration: "underline",
                  color: COLORS.darkText,
                }}
              >
                {displayName}
              </Link>
            ) : (
              <span style={{ color: COLORS.gray }}>{displayName}</span>
            )}
          </span>
        );
      })}
    </Typography>
  );
};

export default Breadcrumbs;
